import {push} from 'connected-react-router';
import moment from 'moment';
import 'moment/locale/pt-br';

import {NotificationService} from '../services';
import {RouteKeys, SituacaoKeys, ViaConviteKeys} from '../constants';
import {AutoCapturaService, AutoCapturaServiceErros} from '../services';
import {EnvService} from '../services';

/**
 * Action Types
 */
export const UPDATE_STATE = 'auto-captura/Customer/UPDATE_STATE';
export const UPDATE_DADOSPESSOAIS =
  'auto-captura/Customer/UPDATE_DADOSPESSOAIS';
export const UPDATE_NATURALIDADE = 'auto-captura/Customer/UPDATE_NATURALIDADE';
export const UPDATE_ENDERECO = 'auto-captura/Customer/UPDATE_ENDERECO';
export const RESET_ENDERECO = 'auto-captura/Customer/RESET_ENDERECO';
export const UPDATE_DADOSDOCUMENTO =
  'auto-captura/Customer/UPDATE_DADOSDOCUMENTO';
export const UPDATE_IMAGEMDOCUMENTO =
  'auto-captura/Customer/UPDATE_IMAGEMDOCUMENTO';
export const UPDATE_PROFISSAO = 'auto-captura/Customer/UPDATE_PROFISSAO';
export const UPDATE_DADOS_ATUALIZAR =
  'auto-captura/Customer/UPDATE_DADOS_ATUALIZAR';
export const UPDATE_CARTAO_CREDITO =
  'auto-captura/Customer/UPDATE_CARTAO_CREDITO';
export const UPDATE_SEGURO_CONTRATADO =
  'auto-captura/Customer/UPDATE_SEGURO_CONTRATADO';
export const UPDATE_PROPS = 'auto-captura/Customer/UPDATE_PROPS';
export const UPDATE_CARTAO_ADICIONAL =
  'auto-captura/Customer/UPDATE_CARTAO_ADICIONAL';

export const DADOSPESSOAIS_PRE_ADICIONAR =
  'auto-captura/Customer/DADOSPESSOAIS_PRE_ADICIONAR';
export const DADOSPESSOAIS_PRE_ADICIONAR_SUCCESS =
  'auto-captura/Customer/DADOSPESSOAIS_PRE_ADICIONAR_SUCCESS';
export const DADOSPESSOAIS_PRE_ADICIONAR_FAIL =
  'auto-captura/Customer/DADOSPESSOAIS_PRE_ADICIONAR_FAIL';

export const DADOSPESSOAIS_ADICIONAR =
  'auto-captura/Customer/DADOSPESSOAIS_ADICIONAR';
export const DADOSPESSOAIS_ADICIONAR_SUCCESS =
  'auto-captura/Customer/DADOSPESSOAIS_ADICIONAR_SUCCESS';
export const DADOSPESSOAIS_ADICIONAR_FAIL =
  'auto-captura/Customer/DADOSPESSOAIS_ADICIONAR_FAIL';

export const DADOSDOCUMENTO_ADICIONAR =
  'auto-captura/Customer/DADOSDOCUMENTO_ADICIONAR';
export const DADOSDOCUMENTO_ADICIONAR_SUCCESS =
  'auto-captura/Customer/DADOSDOCUMENTO_ADICIONAR_SUCCESS';
export const DADOSDOCUMENTO_ADICIONAR_FAIL =
  'auto-captura/Customer/DADOSDOCUMENTO_ADICIONAR_FAIL';

export const ENDERECO_ADICIONAR = 'auto-captura/Customer/ENDERECO_ADICIONAR';
export const ENDERECO_ADICIONAR_SUCCESS =
  'auto-captura/Customer/ENDERECO_ADICIONAR_SUCCESS';
export const ENDERECO_ADICIONAR_FAIL =
  'auto-captura/Customer/ENDERECO_ADICIONAR_FAIL';

export const PROFISSAO_ADICIONAR = 'auto-captura/Customer/PROFISSAO_ADICIONAR';
export const PROFISSAO_ADICIONAR_SUCCESS =
  'auto-captura/Customer/PROFISSAO_ADICIONAR_SUCCESS';
export const PROFISSAO_ADICIONAR_FAIL =
  'auto-captura/Customer/PROFISSAO_ADICIONAR_FAIL';

export const VALIDAR_CODIGO_ACESSO =
  'auto-captura/Customer/VALIDAR_CODIGO_ACESSO';
export const VALIDAR_CODIGO_ACESSO_SUCCESS =
  'auto-captura/Customer/VALIDAR_CODIGO_ACESSO_SUCCESS';
export const VALIDAR_CODIGO_ACESSO_FAIL =
  'auto-captura/Customer/VALIDAR_CODIGO_ACESSO_FAIL';

export const BIOMETRIA_ADICIONAR = 'auto-captura/Customer/BIOMETRIA_ADICIONAR';
export const BIOMETRIA_ADICIONAR_SUCCESS =
  'auto-captura/Customer/BIOMETRIA_ADICIONAR_SUCCESS';
export const BIOMETRIA_ADICIONAR_FAIL =
  'auto-captura/Customer/BIOMETRIA_ADICIONAR_FAIL';

export const PROCESSAR_AUTORIZACAO =
  'auto-captura/Customer/PROCESSAR_AUTORIZACAO';
export const PROCESSAR_AUTORIZACAO_SUCCESS =
  'auto-captura/Customer/PROCESSAR_AUTORIZACAO_SUCCESS';
export const PROCESSAR_AUTORIZACAO_FAIL =
  'auto-captura/Customer/PROCESSAR_AUTORIZACAO_FAIL';

export const REENVIAR_ASSINATURA = 'auto-captura/Customer/REENVIAR_ASSINATURA';
export const REENVIAR_ASSINATURA_SUCCESS =
  'auto-captura/Customer/REENVIAR_ASSINATURA_SUCCESS';
export const REENVIAR_ASSINATURA_FAIL =
  'auto-captura/Customer/REENVIAR_ASSINATURA_FAIL';
export const REMOVE_CARTAO_ADICIONAL =
  'auto-captura/Customer/REMOVE_CARTAO_ADICIONAL';

export const DOCUMENTO_VERSO = 'auto-captura/Customer/DOCUMENTO_VERSO';
export const DOCUMENTO_VERSO_SUCCESS =
  'auto-captura/Customer/DOCUMENTO_VERSO_SUCCESS';
export const DOCUMENTO_VERSO_FAIL =
  'auto-captura/Customer/DOCUMENTO_VERSO_FAIL';

export const DOCUMENTO_FRENTE = 'auto-captura/Customer/DOCUMENTO_FRENTE';
export const DOCUMENTO_FRENTE_SUCCESS =
  'auto-captura/Customer/DOCUMENTO_FRENTE_SUCCESS';
export const DOCUMENTO_FRENTE_FAIL =
  'auto-captura/Customer/DOCUMENTO_FRENTE_FAIL';

export const CARTAO_ADICIONAR = 'auto-captura/Customer/CARTAO_ADICIONAR';
export const CARTAO_ADICIONAR_SUCCESS =
  'auto-captura/Customer/CARTAO_ADICIONAR_SUCCESS';
export const CARTAO_ADICIONAR_FAIL =
  'auto-captura/Customer/CARTAO_ADICIONAR_FAIL';

export const BUSCAR_CEP = 'auto-captura/Customer/BUSCAR_CEP';
export const BUSCAR_CEP_SUCCESS = 'auto-captura/Customer/BUSCAR_CEP_SUCCESS';
export const BUSCAR_CEP_FAIL = 'auto-captura/Customer/BUSCAR_CEP_FAIL';

export const SOLICITAR_CODIGO_SMS =
  'auto-captura/Customer/SOLICITAR_CODIGO_SMS';
export const SOLICITAR_CODIGO_SMS_SUCCESS =
  'auto-captura/Customer/SOLICITAR_CODIGO_SMS_SUCCESS';
export const SOLICITAR_CODIGO_SMS_FAIL =
  'auto-captura/Customer/SOLICITAR_CODIGO_SMS_FAIL';

export const VALIDAR_CODIGO_SMS = 'auto-captura/Customer/VALIDAR_CODIGO_SMS';
export const VALIDAR_CODIGO_SMS_SUCCESS =
  'auto-captura/Customer/VALIDAR_CODIGO_SMS_SUCCESS';
export const VALIDAR_CODIGO_SMS_FAIL =
  'auto-captura/Customer/VALIDAR_CODIGO_SMS_FAIL';

export const ASSINATURA_CONTRATO = 'auto-captura/Customer/ASSINATURA_CONTRATO';
export const ASSINATURA_CONTRATO_SUCCESS =
  'auto-captura/Customer/ASSINATURA_CONTRATO_SUCCESS';
export const ASSINATURA_CONTRATO_FAIL =
  'auto-captura/Customer/ASSINATURA_CONTRATO_FAIL';

export const PRE_AVALIACAO_SOLICITAR =
  'auto-captura/Customer/PRE_AVALIACAO_SOLICITAR';
export const PRE_AVALIACAO_SOLICITAR_SUCCESS =
  'auto-captura/Customer/PRE_AVALIACAO_SOLICITAR_SUCCESS';
export const PRE_AVALIACAO_SOLICITAR_FAIL =
  'auto-captura/Customer/PRE_AVALIACAO_SOLICITAR_FAIL';

export const CONSULTAR_TERMOS_USO =
  'auto-captura/Customer/CONSULTAR_TERMOS_USO';
export const CONSULTAR_TERMOS_USO_SUCCESS =
  'auto-captura/Customer/CONSULTAR_TERMOS_USO_SUCCESS';
export const CONSULTAR_TERMOS_USO_FAIL =
  'auto-captura/Customer/CONSULTAR_TERMOS_USO_FAIL';

export const BUSCAR_SEGUROS_DISPONIVEIS =
  'auto-captura/Customer/BUSCAR_SEGUROS_DISPONIVEIS';
export const BUSCAR_SEGUROS_DISPONIVEIS_SUCCESS =
  'auto-captura/Customer/BUSCAR_SEGUROS_DISPONIVEIS_SUCCESS';
export const BUSCAR_SEGUROS_DISPONIVEIS_FAIL =
  'auto-captura/Customer/BUSCAR_SEGUROS_DISPONIVEIS_FAIL';

export const ADICIONAR_SEGURO_CONTRATADO =
  'auto-captura/Customer/ADICIONAR_SEGURO_CONTRATADO';
export const ADICIONAR_SEGURO_CONTRATADO_SUCCESS =
  'auto-captura/Customer/ADICIONAR_SEGURO_CONTRATADO_SUCCESS';
export const ADICIONAR_SEGURO_CONTRATADO_FAIL =
  'auto-captura/Customer/ADICIONAR_SEGURO_CONTRATADO_FAIL';
export const ADD_CARTAO_ADICIONAL =
  'auto-captura/Customer/ADD_CARTAO_ADICIONAL';
export const ADD_NOVO_CARTAO_ADICIONAL =
  'auto-captura/Customer/ADD_NOVO_CARTAO_ADICIONAL';

export const BUSCAR_SITUACAO_PORTADOR =
  'auto-captura/Customer/BUSCAR_SITUACAO_PORTADOR';
export const BUSCAR_SITUACAO_PORTADOR_SUCCESS =
  'auto-captura/Customer/BUSCAR_SITUACAO_PORTADOR_SUCCESS';
export const BUSCAR_SITUACAO_PORTADOR_FAIL =
  'auto-captura/Customer/BUSCAR_SITUACAO_PORTADOR_FAIL';

export const UPDATE_AUTORIZACAO = 'auto-captura/Customer/UPDATE_AUTORIZACAO';

export const PRE_AVALIACAO_OBTER = 'auto-captura/Customer/PRE_AVALIACAO_OBTER';
export const PRE_AVALIACAO_OBTER_SUCCESS =
  'auto-captura/Customer/PRE_AVALIACAO_OBTER_SUCCESS';
export const PRE_AVALIACAO_OBTER_FAIL =
  'auto-captura/Customer/PRE_AVALIACAO_OBTER_FAIL';

/**
 * Reducer
 */
const initialState = {
  chave: '',
  situacao: '',
  via: '',
  celularOriginalConvite: '',
  realizouPreAvaliacao: false,
  dadosPessoais: {
    nacionalidade: '',
    cpf: '',
    nome: '',
    nascimento: '',
    sexo: '',
    estadoCivil: '',
    nomeDaMae: '',
    celular: '',
    telefoneResidencial: '',
    email: '',
    confirmacaoEmail: '',
    logo: '',
    biometria: null,
  },
  naturalidade: {
    cidade: '',
    uf: '',
  },
  endereco: {
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    telefone: '',
  },
  autorizacoes: false,
  dadosDocumento: {
    numero: '',
    emissao: '',
    orgaoExpedidor: '',
    uf: '',
    imagem: {
      frente: null,
      verso: null,
    },
  },
  profissao: {
    nome: '',
    tipo: '',
    empresa: '',
    rendaMensal: '',
    admissao: '',
    telefone: '',
  },
  autorizacao: [],
  cartao: {
    embossing: '',
    diaDeVencimento: '',
  },
  seguroContratado: '',
  segurosDisponiveis: [],
  urlAcessoDigital: '',
  limitesPreValidados: {
    limitePrimeiraCompraAVista: 0,
    limitePrimeiraCompraTurbinado: 0,
    limitePrimeiraCompraAlcada: 0,
    limitePrimeiraCompraSemJuros: 0,
    exibirLimitesPrimeiraCompra: false,
    limiteCartaoAVista: 0,
    limiteCartaoParcelado: 0,
    exibirLimitesCartao: false,
    limiteTelesaque: 0,
    exibirLimitesTelesaque: false,
  },
  cartoesAdicionais: [
    {
      nomeCompleto: '',
      dataNascimento: '',
      parentesco: '',
      sexo: '',
    },
  ],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATE:
      return {
        ...state,
        payload: action.payload,
      };

    case UPDATE_DADOSPESSOAIS:
      return {
        ...state,
        dadosPessoais: {
          ...state.dadosPessoais,
          [action.payload.prop]: action.payload.value,
        },
      };

    case UPDATE_PROPS:
      return {
        ...state,
        [action.payload.prop]: action.payload.value,
      };

    case UPDATE_NATURALIDADE: {
      return {
        ...state,
        naturalidade: {
          ...state.naturalidade,
          [action.payload.prop]: action.payload.value,
        },
      };
    }

    case UPDATE_ENDERECO: {
      return {
        ...state,
        endereco: {
          ...state.endereco,
          [action.payload.prop]: action.payload.value,
        },
      };
    }

    case RESET_ENDERECO: {
      return {
        ...state,
        endereco: {
          ...state.endereco,
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: '',
        },
      };
    }

    case UPDATE_DADOSDOCUMENTO: {
      return {
        ...state,
        dadosDocumento: {
          ...state.dadosDocumento,
          [action.payload.prop]: action.payload.value,
        },
      };
    }

    case UPDATE_IMAGEMDOCUMENTO: {
      return {
        ...state,
        dadosDocumento: {
          ...state.dadosDocumento,
          imagem: {
            ...state.dadosDocumento.imagem,
            [action.payload.prop]: action.payload.value,
          },
        },
      };
    }

    case UPDATE_PROFISSAO: {
      return {
        ...state,
        profissao: {
          ...state.profissao,
          [action.payload.prop]: action.payload.value,
        },
      };
    }

    case UPDATE_CARTAO_CREDITO: {
      return {
        ...state,
        cartao: {
          ...state.cartao,
          [action.payload.prop]: action.payload.value,
        },
      };
    }

    case UPDATE_AUTORIZACAO: {
      return {
        ...state,
        autorizacao: state.autorizacao.filter(function (item) {
          if (item.codigo === action.payload.prop) {
            item.checked = action.payload.value;
          }
          return item;
        }),
      };
    }

    case UPDATE_SEGURO_CONTRATADO: {
      return {
        ...state,
        seguroContratado: action.payload.value,
      };
    }

    case UPDATE_CARTAO_ADICIONAL: {
      let updatedCartoesAdicionais = [...state.cartoesAdicionais];
      let item = {
        ...updatedCartoesAdicionais[action.payload.index],
        [action.payload.prop]: action.payload.value,
      };
      updatedCartoesAdicionais[action.payload.index] = item;
      return {
        ...state,
        cartoesAdicionais: updatedCartoesAdicionais,
      };
    }

    case ADD_CARTAO_ADICIONAL: {
      const novosCartoesAdicionais = state.cartoesAdicionais.slice();

      return {
        ...state,
        cartoesAdicionais: novosCartoesAdicionais,
      };
    }

    case ADD_NOVO_CARTAO_ADICIONAL: {
      const novoMembro = {
        nomeCompleto: '',
        dataNascimento: '',
        parentesco: '',
        sexo: '',
      };
      const novosCartoesAdicionais = state.cartoesAdicionais.slice();

      if (novosCartoesAdicionais.length < 2) {
        novosCartoesAdicionais.push(novoMembro);
      }
      return {
        ...state,
        cartoesAdicionais: novosCartoesAdicionais,
      };
    }

    case REMOVE_CARTAO_ADICIONAL: {
      const novosCartoesAdicionais = state.cartoesAdicionais.slice();
      novosCartoesAdicionais.splice(action.payload.index, 1);

      return {
        ...state,
        cartoesAdicionais: novosCartoesAdicionais,
      };
    }

    case DADOSPESSOAIS_ADICIONAR_SUCCESS:
    case DADOSPESSOAIS_ADICIONAR_FAIL:
    case DADOSPESSOAIS_PRE_ADICIONAR_SUCCESS:
    case DADOSPESSOAIS_PRE_ADICIONAR_FAIL:
    case ENDERECO_ADICIONAR_SUCCESS:
    case ENDERECO_ADICIONAR_FAIL:
    case DADOSDOCUMENTO_ADICIONAR_SUCCESS:
    case DADOSDOCUMENTO_ADICIONAR_FAIL:
    case PROFISSAO_ADICIONAR_SUCCESS:
    case PROFISSAO_ADICIONAR_FAIL:
    case BIOMETRIA_ADICIONAR_SUCCESS:
    case BIOMETRIA_ADICIONAR_FAIL:
    case REENVIAR_ASSINATURA:
    case REENVIAR_ASSINATURA_SUCCESS:
    case REENVIAR_ASSINATURA_FAIL:
    case DOCUMENTO_VERSO_SUCCESS:
    case DOCUMENTO_VERSO_FAIL:
    case DOCUMENTO_FRENTE_SUCCESS:
    case DOCUMENTO_FRENTE_FAIL:
    case CARTAO_ADICIONAR_SUCCESS:
    case CARTAO_ADICIONAR_FAIL:
      return {...state};
    default:
      return state;
  }
};

export default reducer;

/**
 * Action Creators
 */
export const updateStateCustomer = ({prop, value}) => ({
  type: UPDATE_STATE,
  payload: {prop, value},
});

export const updateDadosPessoais = ({prop, value}) => ({
  type: UPDATE_DADOSPESSOAIS,
  payload: {prop, value},
});

export const updateNaturalidade = ({prop, value}) => ({
  type: UPDATE_NATURALIDADE,
  payload: {prop, value},
});

export const updateDadosDocumento = ({prop, value}) => ({
  type: UPDATE_DADOSDOCUMENTO,
  payload: {prop, value},
});

export const updateSeguroContratado = ({prop, value}) => ({
  type: UPDATE_SEGURO_CONTRATADO,
  payload: {prop, value},
});

export const updateEndereco = ({prop, value}) => ({
  type: UPDATE_ENDERECO,
  payload: {prop, value},
});

export const updateProfissao = ({prop, value}) => ({
  type: UPDATE_PROFISSAO,
  payload: {prop, value},
});

export const updateDadosDocumentoImage = ({prop, value}) => ({
  type: UPDATE_IMAGEMDOCUMENTO,
  payload: {prop, value},
});

export const updateCartaoCredito = ({prop, value}) => ({
  type: UPDATE_CARTAO_CREDITO,
  payload: {prop, value},
});

export const updateCartaoAdicional = ({prop, value, index}) => ({
  type: UPDATE_CARTAO_ADICIONAL,
  payload: {prop, value, index},
});

export const addCartaoAdicional = () => ({
  type: ADD_CARTAO_ADICIONAL,
  payload: {},
});

export const addNovoCartaoAdicional = () => ({
  type: ADD_NOVO_CARTAO_ADICIONAL,
  payload: {},
});

export const removeCartaoAdicional = ({index}) => ({
  type: REMOVE_CARTAO_ADICIONAL,
  payload: {index},
});

export const updateProps = ({prop, value}) => ({
  type: UPDATE_PROPS,
  payload: {prop, value},
});

export const updateAutorizacao = ({prop, value}) => ({
  type: UPDATE_AUTORIZACAO,
  payload: {prop, value},
});

const showErrors = (e, service) => {
  if (EnvService.get('ENV') === 'dev') {
    NotificationService.showValidationSingleError(e.problem);
    console.log(`Requisição ${service} com erro :`, e);
  } else
    NotificationService.showValidationSingleError(
      `Não foi possível ${service}. Por favor, tente novamente mais tarde.`,
    );
};

export const redirectToContinueAfterValidationCode =
  (situation) => async (dispatch) => {
    switch (situation) {
      case SituacaoKeys.Expirado:
        dispatch(push(RouteKeys.CodeExpired.value));
        break;
      case SituacaoKeys.Convidado:
        dispatch(push(RouteKeys.InitialRegistration.value));
        break;
      case SituacaoKeys.Celular:
        dispatch(push(RouteKeys.ConfirmPhoneSuccess.value));
        break;
      case SituacaoKeys.DadosPessoais:
        dispatch(push(RouteKeys.DataDocument.value));
        break;
      case SituacaoKeys.PreAvalicao:
        dispatch(push(RouteKeys.PreEvaluationCompletedSuccess.value));
        break;
      case SituacaoKeys.Cancelada:
      case SituacaoKeys.Negada:
        dispatch(push(RouteKeys.PreEvaluationCompletedFail.value));
        break;
      case SituacaoKeys.Endereco:
        dispatch(push(RouteKeys.DataProfessional.value));
        break;
      case SituacaoKeys.Profissao:
        dispatch(push(RouteKeys.PhotoTime.value));
        break;
      case SituacaoKeys.Documento:
        dispatch(push(RouteKeys.DataResidential.value));
        break;
      case SituacaoKeys.Biometria:
        dispatch(push(RouteKeys.DocumentTime.value));
        break;
      case SituacaoKeys.DocumentoFrente:
        dispatch(push(RouteKeys.DocumentVerse.value));
        break;
      case SituacaoKeys.Seguro:
      case SituacaoKeys.SeguroFinalizado:
      case SituacaoKeys.DocumentoVerso:
      case SituacaoKeys.Assinatura:
      case SituacaoKeys.Autorizacoes:
      case SituacaoKeys.CartaoDeCredito:
        dispatch(push(RouteKeys.YourCard.value));
        break;
      case SituacaoKeys.Assinado:
      case SituacaoKeys.Finalizado:
      case SituacaoKeys.Proposta:
        dispatch(push(RouteKeys.ProposalSendSucess.value));
        break;
      default:
        dispatch(push(RouteKeys.CodeExpired.value));
        break;
    }
  };

export const dadosPessoaisPreAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar dadosPessoaisPreAdicionar');
    dispatch({type: DADOSPESSOAIS_PRE_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      nome: dados.nome.trim(),
      sexo: dados.sexo,
      nascimento: moment(dados.nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      email: dados.email,
      celular: dados.celular.replace(/[^0-9.]/g, ''),
      telefoneResidencial: dados.telefoneResidencial.replace(/[^0-9.]/g, ''),
      autorizacoes: dados.autorizacoes,
    };

    await AutoCapturaService.postDadosPessoaisPreAdicionar(dadosRequest);

    dispatch({type: DADOSPESSOAIS_PRE_ADICIONAR_SUCCESS});

    if (
      dados.via === ViaConviteKeys.Email ||
      dados.via === ViaConviteKeys.CodigoAutocaptura ||
      dados.via === ViaConviteKeys.Promotor
    ) {
      dispatch(push(RouteKeys.ValidateCodeSms.value));
    } else if (
      dados.celularOriginalConvite.replace(/[^0-9.]/g, '') !==
      dados.celular.replace(/[^0-9.]/g, '')
    ) {
      dispatch(push(RouteKeys.ValidateCodeSms.value));
    } else if (!dados.realizouPreAvaliacao) {
      dispatch(push(RouteKeys.ProcessingPreEvaluation.value));
    } else {
      dispatch(push(RouteKeys.EndDataRegistration.value));
    }
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DADOSPESSOAIS_PRE_ADICIONAR_FAIL});
    } else showErrors(e, ' pré adicionar dados pessoais');

    dispatch({type: DADOSPESSOAIS_PRE_ADICIONAR_FAIL});
  }
};

export const dadosPessoaisAdicionar = (dados) => async (dispatch) => {
  try {
    dispatch({type: DADOSPESSOAIS_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      naturalidade: dados.cidade,
      ufDaNaturalidade: dados.uf,
      estadoCivil: dados.estadoCivil,
      nomeDaMae: dados.nomeDaMae.trim(),
      nacionalidade: dados.nacionalidade,
    };

    await AutoCapturaService.postDadosPessoaisAdicionar(dadosRequest);

    dispatch({type: DADOSPESSOAIS_ADICIONAR_SUCCESS});

    dispatch(push(RouteKeys.DataDocument.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DADOSPESSOAIS_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar dados pessoais');

    dispatch({type: DADOSPESSOAIS_ADICIONAR_FAIL});
  }
};

export const dadosDocumentoAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar dadosDocumentoAdicionar');
    dispatch({type: DADOSDOCUMENTO_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      numero: dados.numero,
      emissao: moment(dados.emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      orgaoExpedidor:
        dados.dadosPessoais.nacionalidade === 'Brasileira' ||
        dados.dadosPessoais.nacionalidade === 'Estrangeira'
          ? dados.orgaoExpedidor
          : null,
      uf: dados.dadosPessoais.nacionalidade === 'Brasileira' ? dados.uf : null,
    };

    await AutoCapturaService.postDadosDocumentoAdicionar(dadosRequest);

    dispatch({type: DADOSDOCUMENTO_ADICIONAR_SUCCESS});
    dispatch(push(RouteKeys.DataResidential.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DADOSDOCUMENTO_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar dados documento');

    dispatch({type: DADOSDOCUMENTO_ADICIONAR_FAIL});
  }
};

export const enderecoAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar dadosPessoaisAdicionar');
    dispatch({type: ENDERECO_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      cep: dados.cep.replace('-', ''),
      logradouro: dados.logradouro,
      numero: dados.numero,
      complemento: dados.complemento,
      bairro: dados.bairro,
      cidade: dados.cidade,
      uf: dados.uf,
    };

    await AutoCapturaService.postEnderecoAdicionar(dadosRequest);

    dispatch({type: ENDERECO_ADICIONAR_SUCCESS});
    dispatch(push(RouteKeys.DataProfessional.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DADOSPESSOAIS_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar dados pessoais');

    dispatch({type: ENDERECO_ADICIONAR_FAIL});
  }
};

export const validarCodigoAcesso = (dados) => async (dispatch) => {
  try {
    dispatch({type: VALIDAR_CODIGO_ACESSO});

    const dadosRequest = {
      chave: dados.chave,
      cpf: dados.cpf.replace(/[^0-9]/g, ''),
    };

    const response = await AutoCapturaService.postValidarCodigoAcesso(
      dadosRequest,
    );

    const customer = initialState;
    const {data} = response;

    customer.chave = data.chave;
    customer.situacao = data.situacao;
    customer.via = data.via;
    customer.celularOriginalConvite = data.celular;
    customer.realizouPreAvaliacao = data.realizouPreAvaliacao;

    // DADOS PESSOAIS
    customer.dadosPessoais.cpf = data.cpf ? data.cpf : '';
    customer.dadosPessoais.nome = data.nome ? data.nome : '';
    customer.dadosPessoais.nascimento = data.nascimento
      ? moment(data.nascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : '';

    customer.dadosPessoais.sexo = data.sexo ? data.sexo : '';
    customer.dadosPessoais.estadoCivil = data.estadoCivil
      ? data.estadoCivil
      : '';
    customer.dadosPessoais.nomeDaMae = data.nomeDaMae ? data.nomeDaMae : '';
    customer.dadosPessoais.celular = data.celular
      ? data.celular
          .replace(/^(\d{2})(\d)/g, '($1) $2')
          .replace(/(\d)(\d{4})$/, '$1-$2')
      : '';
    customer.dadosPessoais.telefoneResidencial = data.endereco
      ? data.endereco.telefone
        ? data.endereco.telefone
        : ''
      : '';
    customer.dadosPessoais.email = data.email ? data.email : '';
    customer.dadosPessoais.logo = data.logo ? data.logo : '';
    customer.dadosPessoais.biometria = data.biometria ? data.biometria : '';
    customer.dadosPessoais.nacionalidade = '';

    // CARTAO
    customer.cartao.embossing = data.embossing ? data.embossing : '';
    customer.cartao.diaDeVencimento = data.diaDoVencimento
      ? data.diaDoVencimento
      : '';

    // CARTÕES ADICIONAIS
    customer.cartoesAdicionais = data.cartoesAdicionais
      ? data.cartoesAdicionais.map((cartao) => {
          return {
            dataNascimento: cartao.dataNascimentoCartaoAdicional
              ? moment(
                  cartao.dataNascimentoCartaoAdicional,
                  'YYYY-MM-DD',
                ).format('DD/MM/YYYY')
              : '',
            parentesco: cartao.idRelacaoCartaoAdicional,
            nomeCompleto: cartao.nomeImpressoCartaoAdicional,
            sexo: cartao.sexoCartaoAdicional,
          };
        })
      : [
          {
            dataNascimento: '',
            parentesco: '',
            nomeCompleto: '',
            sexo: '',
          },
        ];

    // NATURALIDADE
    const {naturalidade} = data;
    if (naturalidade) {
      customer.naturalidade.cidade = naturalidade.cidade
        ? naturalidade.cidade
        : '';
      customer.naturalidade.uf = naturalidade.uf ? naturalidade.uf : '';
      customer.dadosPessoais.nacionalidade = data.naturalidade.nacionalidade
        ? data.naturalidade.nacionalidade
        : '';
      customer.dadosDocumento.nacionalidade =
        customer.naturalidade.nacionalidade;
    }

    // ENDERECO
    const {endereco} = data;
    if (endereco) {
      customer.endereco.cep = endereco.cep ? endereco.cep : '';
      customer.endereco.logradouro = endereco.logradouro
        ? endereco.logradouro
        : '';
      customer.endereco.numero = endereco.numero ? endereco.numero : '';
      customer.endereco.complemento = endereco.complemento
        ? endereco.complemento
        : '';
      customer.endereco.bairro = endereco.bairro ? endereco.bairro : '';
      customer.endereco.cidade = endereco.cidade ? endereco.cidade : '';
      customer.endereco.uf = endereco.uf ? endereco.uf : '';
      customer.endereco.telefone = endereco.telefone ? endereco.telefone : '';
    }

    // DOCUMENTO
    const {documento} = data;
    if (documento) {
      customer.dadosDocumento.numero = documento.numero ? documento.numero : '';
      customer.dadosDocumento.emissao = documento.emissao
        ? moment(documento.emissao, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';
      customer.dadosDocumento.orgaoExpedidor = documento.orgaoExpedidor
        ? documento.orgaoExpedidor
        : '';
      customer.dadosDocumento.uf = documento.uf ? documento.uf : '';

      const {imagem} = documento;
      if (imagem) {
        customer.dadosDocumento.imagem.frente = imagem.frente
          ? imagem.frente
          : '';
        customer.dadosDocumento.imagem.verso = imagem.verso ? imagem.verso : '';
      }
    }

    // PROFISSAO
    const {profissao} = data;
    if (profissao) {
      customer.profissao.nome = profissao.nome ? profissao.nome : '';
      customer.profissao.tipo = profissao.tipo ? profissao.tipo : '';
      customer.profissao.empresa = profissao.empresa ? profissao.empresa : '';
      customer.profissao.rendaMensal = profissao.rendaMensal
        ? profissao.rendaMensal
        : '';
      customer.profissao.admissao = profissao.admissao
        ? moment(profissao.admissao, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';
      customer.profissao.telefone = profissao.telefone
        ? profissao.telefone
        : '';
    }

    // PROFISSAO
    const {seguroContratado} = data;
    if (seguroContratado) {
      customer.seguroContratado = seguroContratado;
    }

    console.log('Customer Update Validation:', customer);

    dispatch({
      type: UPDATE_STATE,
      payload: customer,
    });
    dispatch({type: VALIDAR_CODIGO_ACESSO_SUCCESS});

    if (response.data.situacao === SituacaoKeys.Convidado)
      dispatch(push(RouteKeys.InitialRegistration.value));
    else if (
      response.data.situacao === SituacaoKeys.Assinado ||
      response.data.situacao === SituacaoKeys.Finalizado ||
      response.data.situacao === SituacaoKeys.Proposta ||
      response.data.situacao === SituacaoKeys.Aprovada
    )
      dispatch(push(RouteKeys.ProposalSendSucess.value));
    else dispatch(push(RouteKeys.IntermediateReturn.value));
  } catch (e) {
    if (e.status === 400) {
      dispatch({type: VALIDAR_CODIGO_ACESSO_FAIL});

      if (e.data && e.data.erro === 'ConviteExpiradoException') {
        dispatch(push(RouteKeys.CodeExpired.value));
      } else
        NotificationService.showValidationSingleError(
          AutoCapturaServiceErros.mapErrosResponse(e),
        );
    } else showErrors(e, ' validar código acesso');

    dispatch({type: VALIDAR_CODIGO_ACESSO_FAIL});
  }
};

export const processaSituacaoPortadorFinalizada =
  (dados) => async (dispatch) => {
    try {
      dispatch({type: BUSCAR_SITUACAO_PORTADOR});

      const response = await AutoCapturaService.getPortadorSituacao(dados);
      dispatch({type: BUSCAR_SITUACAO_PORTADOR_SUCCESS});
      const {situacao} = response.data;

      let retorno = false;

      switch (situacao) {
        case SituacaoKeys.Assinado:
        case SituacaoKeys.Proposta:
        case SituacaoKeys.Assinatura:
        case SituacaoKeys.Finalizado: {
          console.log(
            'Enviando para tela de proposta enviada com sucesso.....',
          );
          dispatch(push(RouteKeys.ProposalSendSucess.value));
          retorno = true;
          break;
        }
        default:
          console.log('Continua na mesma tela....');
          retorno = false;
          break;
      }

      return retorno;
    } catch (e) {
      if (e.status === 400) {
        NotificationService.showValidationSingleError(
          AutoCapturaServiceErros.mapErrosResponse(e),
        );
        dispatch({type: BUSCAR_SITUACAO_PORTADOR_FAIL});
      } else showErrors(e, ' adicionar dados documento');

      dispatch({type: BUSCAR_SITUACAO_PORTADOR_FAIL});
    }
  };

export const profissaoAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar dadosProfissionaisAdicionar');
    dispatch({type: PROFISSAO_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      nome: dados.nome,
      tipo: dados.tipo,
      empresa: dados.empresa,
      rendaMensal: dados.rendaMensal
        .toString()
        .replace(/[^0-9,]/g, '')
        .replace(',', '.'),
      admissao:
        dados.admissao !== ''
          ? moment(dados.admissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : '',
      telefone: dados.telefone.replace(/[^0-9.]/g, ''),
    };

    await AutoCapturaService.postProfissaoAdicionar(dadosRequest);

    dispatch({type: PROFISSAO_ADICIONAR_SUCCESS});
    dispatch(push(RouteKeys.PhotoTime.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: PROFISSAO_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar dados profissionais');

    dispatch({type: PROFISSAO_ADICIONAR_FAIL});
  }
};

export const biometriaAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar biometriaAdicionar');
    dispatch({type: BIOMETRIA_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      selfie: dados.biometria,
    };

    await AutoCapturaService.postBiometriaAdicionar(dadosRequest);

    dispatch({type: BIOMETRIA_ADICIONAR_SUCCESS});
    dispatch(push(RouteKeys.DocumentTime.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: BIOMETRIA_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar a sua selfie ');

    dispatch({type: BIOMETRIA_ADICIONAR_FAIL});
  }
};

export const processarAutorizacao = (dados) => async (dispatch) => {
  try {
    dispatch({type: PROCESSAR_AUTORIZACAO});

    const dadosRequest = {
      chave: dados.chave,
      termos: dados.autorizacao,
    };

    const response = await AutoCapturaService.postProcessarAutorizacao(
      dadosRequest,
    );

    if (response.data && response.data.sucesso) {
      dispatch({
        type: UPDATE_PROPS,
        payload: {prop: 'urlAcessoDigital', value: response.data.url},
      });
    }
    dispatch({type: PROCESSAR_AUTORIZACAO_SUCCESS});

    return response.data;
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: PROCESSAR_AUTORIZACAO_FAIL});
    } else showErrors(e, ' processar autorizações');

    dispatch({type: PROCESSAR_AUTORIZACAO_FAIL});
  }
};

export const reenviarAssinatura = (dados) => async (dispatch) => {
  try {
    dispatch({type: REENVIAR_ASSINATURA});

    const dadosRequest = {
      chave: dados.chave,
      email: dados.email,
      celular: dados.celular.replace(/[^0-9.]/g, ''),
    };

    await AutoCapturaService.postReenviarAssinatura(dadosRequest);

    dispatch({type: REENVIAR_ASSINATURA_SUCCESS});

    dispatch(push(RouteKeys.LinkResendedSucess.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: REENVIAR_ASSINATURA_FAIL});
    } else showErrors(e, ' reenviar assinatura');

    dispatch({type: REENVIAR_ASSINATURA_FAIL});
  }
};

export const documentoVersoAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar documentoVerso');
    dispatch({type: DOCUMENTO_VERSO});

    const dadosRequest = {
      chave: dados.chave,
      imagem: dados.imagem,
    };

    await AutoCapturaService.postDocumentoVerso(dadosRequest);

    dispatch({type: DOCUMENTO_VERSO_SUCCESS});
    dispatch(push(RouteKeys.YourCard.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DOCUMENTO_VERSO_FAIL});
    } else showErrors(e, ' documento verso ');

    dispatch({type: DOCUMENTO_VERSO_FAIL});
  }
};

export const documentoFrenteAdicionar = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar documentoFrente');
    dispatch({type: DOCUMENTO_FRENTE});

    const dadosRequest = {
      chave: dados.chave,
      imagem: dados.imagem,
    };

    await AutoCapturaService.postDocumentoFrente(dadosRequest);

    dispatch({type: DOCUMENTO_FRENTE_SUCCESS});
    dispatch(push(RouteKeys.DocumentVerse.value));
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: DOCUMENTO_FRENTE_FAIL});
    } else showErrors(e, ' verificar a frente do seu documento');
    dispatch({type: DOCUMENTO_FRENTE_FAIL});
  }
};

export const adicionarCartao = (dados) => async (dispatch) => {
  console.log(`DADOS ENTRADA CARTÃO -> ${JSON.stringify(dados)}`);
  try {
    dispatch({type: CARTAO_ADICIONAR});

    const dadosRequest = {
      chave: dados.chave,
      embossing: dados.embossing,
      diaDeVencimento: dados.diaDeVencimento,
    };

    const response = await AutoCapturaService.postAdicionarCartao(dadosRequest);

    console.log(`RESPONSE COSTUMER -> ${JSON.stringify(response)}`);

    dispatch({type: CARTAO_ADICIONAR_SUCCESS});
  } catch (e) {
    console.log(`ERRO NO ADICIONAR CARTAO -> ${JSON.stringify(e)}`);
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: CARTAO_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar cartão');

    dispatch({type: CARTAO_ADICIONAR_FAIL});
  }
};

export const adicionarCartoesAdicionais = (dados) => async (dispatch) => {
  console.log(`DADOS ENTRADA CARTÃO ADICIONAL -> ${JSON.stringify(dados)}`);
  try {
    dispatch({type: ADD_CARTAO_ADICIONAL});

    dados.cartoes = dados.cartoes.map((cartao) => {
      cartao.dataNascimento = moment(
        cartao.dataNascimento,
        'DD/MM/YYYY',
      ).format('YYYY-MM-DD');
      return cartao;
    });

    const response = await AutoCapturaService.postAdicionarCartoesAdicionais(
      dados,
    );

    console.log(
      `RESPONSE COSTUMER CARTAO ADICIONAL -> ${JSON.stringify(response)}`,
    );
    dispatch({type: CARTAO_ADICIONAR_SUCCESS});
  } catch (e) {
    console.log(`ERRO NO ADICIONAR CARTAO ADICIONAL -> ${JSON.stringify(e)}`);
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: CARTAO_ADICIONAR_FAIL});
    } else showErrors(e, ' adicionar cartão');

    dispatch({type: CARTAO_ADICIONAR_FAIL});
  }
};

export const buscaCep = (dados) => async (dispatch) => {
  try {
    console.log('Iniciar Busca Cep');
    dispatch({type: BUSCAR_CEP});

    const dadosRequest = {
      cep: dados.replace(/[^0-9.]/g, ''),
    };

    const response = await AutoCapturaService.postBuscaCep(dadosRequest);

    dispatch({type: BUSCAR_CEP_SUCCESS});
    dispatch({type: RESET_ENDERECO});

    if (response.cep) {
      dispatch({
        type: UPDATE_ENDERECO,
        payload: {prop: 'cep', value: response.cep},
      });
    }

    if (response.logradouro) {
      dispatch({
        type: UPDATE_ENDERECO,
        payload: {prop: 'logradouro', value: response.logradouro},
      });
    }

    if (response.bairro) {
      dispatch({
        type: UPDATE_ENDERECO,
        payload: {prop: 'bairro', value: response.bairro},
      });
    }

    if (response.uf) {
      dispatch({
        type: UPDATE_ENDERECO,
        payload: {prop: 'uf', value: response.uf},
      });
    }

    if (response.cidade) {
      dispatch({
        type: UPDATE_ENDERECO,
        payload: {
          prop: 'cidade',
          value: response.cidade.replace(new RegExp(/(.+)\s(\(.+\))/g), '$1'),
        },
      });
    }

    return response;
  } catch (e) {
    dispatch({type: RESET_ENDERECO});

    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: BUSCAR_CEP_FAIL});
    } else showErrors(e, ' buscar cep ');

    dispatch({type: BUSCAR_CEP_FAIL});
  }
};

export const solicitarCodigoViaSms = (dados) => async (dispatch) => {
  try {
    dispatch({type: SOLICITAR_CODIGO_SMS});

    const dadosRequest = {
      chave: dados.chave,
      celular: dados.celular.replace(/[^0-9.]/g, ''),
    };

    await AutoCapturaService.postSolicitarCodigoViaSms(dadosRequest);
    dispatch({type: SOLICITAR_CODIGO_SMS_SUCCESS});
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: SOLICITAR_CODIGO_SMS_FAIL});
    } else showErrors(e, ' solicitar codigo via sms ');

    dispatch({type: SOLICITAR_CODIGO_SMS_FAIL});
  }
};

export const validarCodigoViaSms = (dados) => async (dispatch) => {
  try {
    dispatch({type: VALIDAR_CODIGO_SMS});

    const dadosRequest = {
      chave: dados.chave,
      codigo: dados.codigo,
    };

    let response = await AutoCapturaService.postValidarCodigoViaSms(
      dadosRequest,
    );
    dispatch({type: VALIDAR_CODIGO_SMS_SUCCESS});

    return response.valido;
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: VALIDAR_CODIGO_SMS_FAIL});
    } else showErrors(e, ' validar codigo via sms ');

    dispatch({type: VALIDAR_CODIGO_SMS_FAIL});
  }
};

export const verAssinaturaContrato = (dados) => async (dispatch) => {
  try {
    dispatch({type: ASSINATURA_CONTRATO});
    const dadosRequest = {
      chave: dados.chave,
    };

    let response = await AutoCapturaService.postAssinaturaContrato(
      dadosRequest,
    );
    dispatch({type: ASSINATURA_CONTRATO_SUCCESS});

    return response;
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: ASSINATURA_CONTRATO_FAIL});
    } else showErrors(e, ' ver contrato da assinatura ');

    dispatch({type: ASSINATURA_CONTRATO_FAIL});
  }
};

export const preAvaliacaoSolicitar = (dados) => async (dispatch) => {
  try {
    dispatch({type: PRE_AVALIACAO_SOLICITAR});
    const dadosRequest = {
      chave: dados.chave,
    };

    let response = await AutoCapturaService.postPreAvaliacaoSolicitar(
      dadosRequest,
    );
    dispatch({type: PRE_AVALIACAO_SOLICITAR_SUCCESS});

    if (response.aprovado) {
      dispatch({
        type: UPDATE_PROPS,
        payload: {prop: 'situacao', value: SituacaoKeys.PreAvalicao},
      });

      dispatch({
        type: UPDATE_PROPS,
        payload: {prop: 'realizouPreAvaliacao', value: true},
      });

      dispatch(push(RouteKeys.PreEvaluationCompletedSuccess.value));
    } else if (response.reprocessar) {
      dispatch(push(RouteKeys.RemakePreEvaluation.value));
    } else {
      dispatch(push(RouteKeys.PreEvaluationCompletedFail.value));
    }
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: PRE_AVALIACAO_SOLICITAR_FAIL});
    } else showErrors(e, ' solicitar pré-avaliação ');

    dispatch({type: PRE_AVALIACAO_SOLICITAR_FAIL});
  }
};

export const consultarTermosUso = (dados) => async (dispatch) => {
  try {
    dispatch({type: CONSULTAR_TERMOS_USO});

    const dadosRequest = {
      chave: dados,
    };

    let response = await AutoCapturaService.getConsultarTermosUso(dadosRequest);

    dispatch({
      type: UPDATE_PROPS,
      payload: {prop: 'autorizacao', value: mapAutorizacao(response.termos)},
    });

    dispatch({type: CONSULTAR_TERMOS_USO_SUCCESS});
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: CONSULTAR_TERMOS_USO_FAIL});
    } else showErrors(e, ' consultar termos de uso ');

    dispatch({type: CONSULTAR_TERMOS_USO_FAIL});
  }
};

export const consultarSegurosDisponiveis = (chave) => async (dispatch) => {
  try {
    let response = await AutoCapturaService.getBuscarSeguros(chave);
    let seguros = mapSeguros(response.seguros);

    dispatch({
      type: UPDATE_PROPS,
      payload: {prop: 'segurosDisponiveis', value: seguros},
    });

    return response;
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
    } else showErrors(e, ' consultar seguros disponíveis ');
  }
};

export const adicionarSeguroContratado = (chave, dados) => async (dispatch) => {
  try {
    dispatch({type: ADICIONAR_SEGURO_CONTRATADO});

    if (dados !== null) {
      const dadosRequest = {
        id: dados.id,
        codigo: dados.codigo,
        nome: dados.nome,
        descricao: dados.descricao,
        valor: dados.valor,
        valorPremio: dados.valorPremio,
        cor: dados.cor,
      };
      await AutoCapturaService.postAdicionarSeguroContratado(
        chave,
        dadosRequest,
      );
    } else
      await AutoCapturaService.postAdicionarSeguroContratado(chave, {
        id: 0,
        codigo: '',
        nome: '',
        descricao: '',
        valor: 0,
        valorPremio: 0,
        cor: '',
      });

    dispatch({type: ADICIONAR_SEGURO_CONTRATADO_SUCCESS});
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: ADICIONAR_SEGURO_CONTRATADO_FAIL});
    } else showErrors(e, ' adicionar seguro contratado');

    dispatch({type: ADICIONAR_SEGURO_CONTRATADO_FAIL});
  }
};

export const preAvaliacaoObter = (dados) => async (dispatch) => {
  try {
    dispatch({type: PRE_AVALIACAO_OBTER});

    let response = await AutoCapturaService.getPreAvaliacaoObter(dados);
    dispatch({type: PRE_AVALIACAO_OBTER_SUCCESS});

    const {limitesPreValidados} = response.data;
    if (
      limitesPreValidados !== null &&
      (limitesPreValidados.limitePrimeiraCompraAVista > 0 ||
        limitesPreValidados.limitePrimeiraCompraTurbinado > 0 ||
        limitesPreValidados.limitePrimeiraCompraAlcada > 0 ||
        limitesPreValidados.limitePrimeiraCompraSemJuros > 0 ||
        limitesPreValidados.limiteCartaoAVista > 0 ||
        limitesPreValidados.limiteCartaoParcelado > 0 ||
        limitesPreValidados.limiteTelesaque > 0)
    ) {
      dispatch({
        type: UPDATE_PROPS,
        payload: {prop: 'limitesPreValidados', value: limitesPreValidados},
      });
    }
  } catch (e) {
    if (e.status === 400) {
      NotificationService.showValidationSingleError(
        AutoCapturaServiceErros.mapErrosResponse(e),
      );
      dispatch({type: PRE_AVALIACAO_OBTER_FAIL});
    } else {
      NotificationService.showValidationSingleError(
        'Não foi possível exibir os Limites Pré-Validados',
      );
    }

    dispatch({type: PRE_AVALIACAO_OBTER_FAIL});
  }
};

const mapAutorizacao = (termos) => {
  return termos.map((t) => ({
    codigo: t.codigo,
    termo: t.termo,
    link: t.link,
    checked: false,
  }));
};

const mapSeguros = (seguros) => {
  return seguros.map((t) => ({
    id: t.id,
    codigo: t.codigo,
    nome: t.nome,
    descricao: t.descricao,
    valor: t.valor,
    valorPremio: t.valorPremio,
    cor: t.cor,
  }));
};
